import React from "react";

import FormInput from "Common/Custom/FormInput";

import FormSubmitButton from "Common/Custom/FormSubmitButton";

import PageBody from "Common/Custom/PageBody";

import { HeadingOne } from "Common/Custom/HeadingOne";

import FormTextarea from "Common/Custom/FormTextarea";

import PropTypes from "prop-types";



const EditFoodpackageForm = ({

    values = {},

    errors = {},

    handleChange = () => { },

    handleSubmit = () => { },

    fields = {},

    loading = false,

}) => {



    return (

        <PageBody onSubmit={handleSubmit} headerchildren={

            <HeadingOne>Edit Food Package</HeadingOne>

        }>

            {

                fields?.map((field) => {

                    if (field.type === "textarea") {

                        return (

                            <FormTextarea

                                key={field.name}

                                field={field}

                                value={values[field.name]}

                                handleChange={handleChange}

                                error={errors[field.name]}

                            />

                        );

                    }

                    return (

                        <FormInput

                            key={field.name}

                            field={field}

                            value={values[field.name]}

                            handleChange={handleChange}

                            error={errors[field.name]}

                        />

                    );

                })

            }



            <FormSubmitButton

                label="Update"

                loading={loading}

                colSize="col-12"

                align="end"

            />

        </PageBody>

    );

};



EditFoodpackageForm.propTypes = {

    values: PropTypes.object,

    errors: PropTypes.object,

    handleChange: PropTypes.func,

    handleSubmit: PropTypes.func,

    loading: PropTypes.bool,

    fields: PropTypes.array,

};





EditFoodpackageForm.defaultProps = {

    values: {},

    errors: {},

    handleChange: () => { },

    handleSubmit: () => { },

    loading: false,

    fields: [],

}

export default EditFoodpackageForm;

